export class  DocumentFB{
    id:string
    Name:string;
    Location:string;
    UserId:Array<string>;
    Version: Array<string>;
    Folder: boolean = false;
}   